const getDefaultState = () => {
  return {
    channelArr: [],
    channelType: -1,
    channelName: '',
    queryType: 1,
    queryValue: '',
    findValue: 0
  }
}

const state = getDefaultState()

const mutations = {
  SET_CHANNEL_ARR: (state, channelArr) => {
    state.channelArr = channelArr
  },
  SET_CHANNEL: (state, channel) => {
    state.channelType = channel.id
    state.channelName = channel.channelName
  },
  SET_QUERYTYPE: (state, queryType) => {
    state.queryType = queryType
  },
  SET_QUERYVALUE: (state, queryValue) => {
    state.queryValue = queryValue
  },
  SET_FINDVALUE: (state) => {
    state.findValue++
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/industry.js